
export const trimSeconds = (timeString) => {
    if (!timeString) return '-';
    
    try {
        // Split time string into hours, minutes, seconds
        const [hours, minutes] = timeString.split(':');
        return `${hours}:${minutes}`;
    } catch (error) {
        console.error('Error trimming seconds:', error);
        return timeString;
    }
};

export const formatTimeToHoursMinutes = (timeString) => {
    if (!timeString) return '-';
    
    try {
        // Split time string into components
        const [hours, minutes] = timeString.split(':');
        
        // Convert to numbers
        const h = parseInt(hours);
        const m = parseInt(minutes);
        
        // Handle invalid values
        if (isNaN(h) || isNaN(m)) return timeString;
        
        // Format the string
        if (h === 0) {
            return m > 0 ? `${m}m` : '0m';
        }
        
        return m > 0 ? `${h}h ${m}m` : `${h}h`;
        
    } catch (error) {
        console.error('Error formatting time:', error);
        return timeString;
    }
};

export const formatDuration = (durationString) => {
    if (!durationString) return '-';
    
    try {
        // Check if duration contains hours
        const hasHours = durationString.includes('hours') || durationString.includes('hour');
        const hasMinutes = durationString.includes('mins') || durationString.includes('min');
        
        let hours = 0;
        let minutes = 0;
        
        // Extract hours if present
        if (hasHours) {
            const hourMatch = durationString.match(/(\d+)\s*hours?/);
            hours = hourMatch ? parseInt(hourMatch[1]) : 0;
        }
        
        // Extract minutes if present
        if (hasMinutes) {
            const minMatch = durationString.match(/(\d+)\s*mins?/);
            minutes = minMatch ? parseInt(minMatch[1]) : 0;
        }
        
        // Format the output
        if (hours === 0) {
            return minutes > 0 ? `${minutes}m` : '0m';
        }
        
        return minutes > 0 ? `${hours}h ${minutes}m` : `${hours}h`;
        
    } catch (error) {
        console.error('Error formatting duration:', error);
        return durationString;
    }
};

export const formatDate = (dateString,two_digit = false) => {
    if (!dateString) return '-';
    
    try {
        const date = new Date(dateString);
        
        // Check if date is valid
        if (isNaN(date.getTime())) {
            return dateString;
        }
        const months = [
            "Jan", "Feb", "Mar", "Apr", "May", "Jun", 
            "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
        ];

        // Get day, month and year
        const day = date.getDate().toString().padStart(2, '0');
        const month = months[date.getMonth()];
        const year = date.getFullYear();
        const formattedYear = two_digit ? String(year).slice(-2) : year;

        // Return formatted date
        return `${day} ${month} ${formattedYear}`;
        
    } catch (error) {
        console.error('Error formatting date:', error);
        return dateString;
    }
}; 

export const generateDateHeaders = (startDate, endDate) => {
    const start = new Date(startDate);
    const end = new Date(endDate);
    const dates = [];

    // Iterate from start to end date, adding each date to the array
    while (start <= end) {
        dates.push(new Date(start));  // Push the date into the array
        start.setDate(start.getDate() + 1); // Increment by 1 day
    }
    
    return dates;
};

export const formatMonth = (date) => {
    
    const day = String(date.getDate()).padStart(2, '0');
    const month = (date.getMonth()+1).toString().padStart(2,'0');
    const year = date.getFullYear();
    

    return `${day}-${month}-${year}`;
};
export const formatDateShort = (dateString) => {
    if (!dateString) return '-';
    
    try {
        const date = new Date(dateString);
        
        // Check if date is valid
        if (isNaN(date.getTime())) {
            return dateString;
        }

        // Get day, month and year
        const day = date.getDate().toString().padStart(2, '0');
        const monthIndex = date.getMonth(); // Month is 0-based
        const year = date.getFullYear();

        // Array of month names
        const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", 
                            "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
        
        // Return formatted date
        return `${day}${monthNames[monthIndex]}${year}`;
        
    } catch (error) {
        console.error('Error formatting date:', error);
        return dateString;
    }
};
export const convertToIST = (time24) => {
    if (!time24 || typeof time24 !== "string") return "Invalid Time";
  
    const [hours, minutes] = time24.split(":").map(Number);
    if (isNaN(hours) || isNaN(minutes) || hours > 23 || minutes > 59) {
      return "Invalid Time";
    }
  
    const period = hours >= 12 ? "PM" : "AM";
    const hours12 = hours % 12 || 12; // Convert 0 to 12 for 12 AM case
    
    return `${hours12}:${String(minutes).padStart(2, "0")} ${period}`;
  };
  